import React, { useMemo } from 'react';
import classnames from 'classnames';
import { Layout, Text } from "tea-component";
import { useProps } from "@/pages/dashboard/components/PageContainer/Render/hooks";
import Render from '@/pages/dashboard/components/PageContainer/Render';
import { useIntl } from 'umi';
import { LANGUAGE_EN } from '@home/_config/config';
import { getName } from '@home/utils/common';
import { IProps, ITitleName } from './_type';
import SvgIcon from '@home/components/SvgIcon';
import { dynamicString } from '@home/utils/dynamicString';
import { IComponentType } from '@/pages/dashboard/components/PageContainer/type';

const { Content } = Layout;

const CommonHeader = (props: IProps) => {
  const { config, children, className, style } = props;
  const {
    title,
    subtitle,
    titleIcon,
    titleCn,
    subtitleCn,
    operationList,
    operationListCn,
    timeZone = '+0',
    showTimeZone = false,
    customSubTitle = false,
    headerSlot,
  } = config || {};
  const { data, changeData } = useProps(props);
  const { locale } = useIntl();
  const isEn = locale === LANGUAGE_EN;

  const subTitle = useMemo(() => {
  
    // 没配时区，默认展示0时区
    const subTitle = `Timezone (UTC${timeZone || '+0'})`;
    const subTitleCN = `时区 (UTC${timeZone || '+0'})`;
    const context = { timeZone, ...data };
    if (subtitle) {
      if (isEn) {
        return dynamicString(subtitle, context) || '';
      }
      return subtitleCn ? dynamicString(subtitleCn, context) : dynamicString(subtitle, context) || '';
    }
    if (!showTimeZone) return '';
    return (isEn && subTitle ? subTitle : subTitleCN) || '';
  }, [timeZone, data, subtitle, showTimeZone, isEn, subtitleCn]);

  // 根据传参类型渲染组件
  const renderComponent = (renderContent: string | ITitleName, renderContentCn: string | ITitleName) => {
    if (typeof renderContent === 'string' && typeof renderContentCn === 'string') {
      return getName(isEn, renderContent, renderContentCn);
    }
    return <Render config={renderContent} data={data} changeData={changeData} />;
  };

  return <Content className={classnames(className)} style={style}>
    <Content.Header
      title={
        <>
          {titleIcon && <SvgIcon type={titleIcon} />}
          {title && renderComponent(title, titleCn)}
        </>
      }
      subtitle={
        customSubTitle
          ? <Text theme="label">{subTitle}</Text>
          : (subtitle && renderComponent(subtitle, subtitleCn)) || null
      }
      operation={
        <>
          {operationList && renderComponent(operationList, operationListCn)}
        </>
      }
    >
      {
        headerSlot && headerSlot.length > 0 && (
          <div className="dbd-common-header-slot">
            {headerSlot.map((item: IComponentType, index: number) => (
              <Render
                key={`header-child-${item.name}_${index}`}
                config={item}
                data={data}
                changeData={changeData}
              />
            ))}
          </div>
        )
      }
    </Content.Header>
    <Content.Body full>
      {
        children?.map((item, index: number) => {
          const { config, data, changeData } = item?.props || {};
          return <>
            <Render config={config} key={config?.name + index} data={data} changeData={changeData} />
          </>;
        })
      }
    </Content.Body>
  </Content>;
};

export default CommonHeader;